"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGeoIPDetails = exports.geoipOverride = exports.geoipDebuggingOverride = void 0;
const countries_1 = require("./countries");
const isProd_1 = __importDefault(require("../isProd"));
/**
 * geoipDebuggingOverride uses the URL parameters to override the geo location params
 * for debugging purposes.
 * @param geoip
 * @param url The request URL
 */
function geoipDebuggingOverride(geoip, url) {
    const country_code = url.searchParams.get('fcc');
    if (!country_code) {
        return geoip;
    }
    // Get the continent either from a direct override or based on the country override
    const is_eu_citizen = countries_1.EU_COUNTRIES.includes(country_code);
    const continent_code = url.searchParams.get('fcoc') || (is_eu_citizen ? 'EU' : 'NA');
    const city_name = url.searchParams.get('fcn') || geoip.city_name;
    const subdivision = url.searchParams.get('fsub') || geoip.subdivision;
    const postal_code = url.searchParams.get('fpc') || geoip.postal_code;
    if (!isProd_1.default) {
        console.log(`GeoIP overridden by search params (country: ${country_code}, continent: ${continent_code})`);
    }
    return Object.assign({}, geoip, {
        continent_code,
        country_code,
        city_name,
        subdivision,
        postal_code,
        is_eu_citizen,
        is_forced_country_code: true,
    });
}
exports.geoipDebuggingOverride = geoipDebuggingOverride;
/**
 * geoipOverride uses the URL parameters to override the country code
 * currently serves mostly for enrollment flow
 * @param geoip
 * @param url The request URL
 */
function geoipOverride(geoip, url) {
    var _a;
    const country_code = ((_a = url.searchParams) === null || _a === void 0 ? void 0 : _a.get('cc')) || geoip['country_code'];
    return Object.assign({}, geoip, { country_code });
}
exports.geoipOverride = geoipOverride;
/**
 * geoipLookup finds city information based on an IP address using the maxmind
 * database. If the DB is unavailable or the IP address can't be associated
 * with a city, it defaults to US as the country and NA as the continent.
 * @returns An object with location information associated with the IP address
 * @param geoip
 * @param url
 */
function getGeoIPDetails(geoip, url) {
    var _a, _b, _c, _d, _e, _f;
    const country_code = ((_a = geoip === null || geoip === void 0 ? void 0 : geoip.country) === null || _a === void 0 ? void 0 : _a.iso_code) || 'US';
    const continent_code = ((_b = geoip === null || geoip === void 0 ? void 0 : geoip.continent) === null || _b === void 0 ? void 0 : _b.code) || 'NA';
    const city_name = ((_d = (_c = geoip === null || geoip === void 0 ? void 0 : geoip.city) === null || _c === void 0 ? void 0 : _c.names) === null || _d === void 0 ? void 0 : _d.en) || '';
    const postal_code = ((_e = geoip === null || geoip === void 0 ? void 0 : geoip.postal) === null || _e === void 0 ? void 0 : _e.code) || '';
    // Get the most confident subvision, if subdivisions exist
    const subdivision = ((_f = geoip === null || geoip === void 0 ? void 0 : geoip.subdivisions) === null || _f === void 0 ? void 0 : _f.length)
        ? geoip.subdivisions.reduce((prev, cur) => {
            if ((prev.confidence || 0) >= (cur.confidence || 0)) {
                return prev;
            }
            return cur;
        }, geoip.subdivisions[0]).iso_code
        : '';
    const is_eu_citizen = countries_1.EU_COUNTRIES.includes(country_code);
    const extractedGeoLocation = {
        continent_code,
        country_code,
        city_name,
        postal_code,
        subdivision,
        is_eu_citizen,
        is_forced_country_code: false,
    };
    // Only modifies real geoip if using forcing parameters in url
    const debuggingGeoip = geoipDebuggingOverride(extractedGeoLocation, url);
    return geoipOverride(debuggingGeoip, url);
}
exports.getGeoIPDetails = getGeoIPDetails;
//# sourceMappingURL=lookup.js.map